import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup} from '@angular/forms';
import { AuthenticationService } from '../../core/services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SubSink } from 'subsink';


@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {
  loginForm: UntypedFormGroup;
  subSink = new SubSink();
  errorServer: string;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService) { }

  ngOnInit() {
  }

  
  formSubmit(ev){
    this.subSink.add(this.authenticationService.login(ev.email, ev.username, ev.password).subscribe(data=>{
        if(data){
          let token = data.token;
            if (token) {
              this.authenticationService.setLogIn(JSON.stringify({ token: token }));
              this.router.navigate(['/articles']);
            }
            else{
              console.log("error", data.message); 
              this.errorServer = data.message;
            }
          console.log("DATA", data)
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

}
